import React from "react";
import {BaseStaticFieldModalProps} from "../DynamicFormTypes.ts";
import Modal from "../../Modal.tsx";
import SamButton from "../../SamButton.tsx";
import {useFormActions, useFormMethods, useFormStatic} from "../DyanmicFormContext.tsx";
import {NotificationType, useNotification} from "../../../context/NotificationContext.tsx";

export const ClearEffectiveDateModal: React.FC<BaseStaticFieldModalProps> = React.memo(({
                                                                                   isOpen,
                                                                                   onClose
                                                                               }) => {
    const { formMethods } = useFormMethods();
    const { clearProgress } = useFormActions();
    const { formPermissions } = useFormStatic();
    const { showNotification } = useNotification();

    const clearEffectiveDate = () => {
        if (!formPermissions.canEdit) {
            console.warn("Edits or auto set values are not allowed");
            showNotification(NotificationType.INFO, "Edits or auto set values are not allowed");
            onClose();
            return;
        }
        formMethods.setValue("isEffectiveDateConfirmed", false);
        clearProgress();
        onClose();
    }

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={"Confirm Effective Date?"}
        >
            <div className="flex flex-col space-y-1 mb-3">
                <label className="text-md font-medium text-red-700">Changing the Effective Date will clear the Selected Comparables section</label>
            </div>

            <div className="flex justify-between">
                <SamButton
                    onClick={onClose}
                >
                    Cancel
                </SamButton>
                <SamButton
                    onClick={clearEffectiveDate}
                >
                    Clear Effective Date
                </SamButton>
            </div>
        </Modal>
    );

});